<template>
    <!-- Company Profile Edit Component -->
    <div class="page-layout blank contacts-manage">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                </div>
            </div>
        </div>
        <div class="pb-10" v-else-if="!ajaxCallinprogress && company_details">
            <div class="page-layout carded bordertransparent left-sidebar" style="overflow-y: visible;">
                <div class="page-content-wrapper" style="border-radius: 15px;">
                    <div class="page-content custom-scrollbar py-4 px-1" style="border-radius: 15px;">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="w-100 pt-4 px-1 pb-2">
                                    <div class="page-layout carded" style="background-color: #d6e2ef !important;">
                                        <div class="cover-pic row ml-0 mr-0">
                                            <img :src="company_details.cover_pic" class="h-100 w-100" />
                                            <div class="mt-3 fs-14 pl-3 pt-1 pointer custom-background-upload">
                                                <label
                                                    class="icon icon-picture text-white d-block fs-14 pr-1 w-100 pointer">
                                                    <input type="file" ref="myCompanyCoverpic"
                                                        accept="image/x-png, image/gif, image/jpeg"
                                                        @change="onCompanyBackground" />
                                                    <span class="ml-3 text-white font-weight-bold"
                                                        style="font-family: 'Poppins', sans-serif !important;">Change
                                                        Picture</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-block companyPic">
                                            <img class="avatar huge bg-white" :src="company_details.logo" />
                                            <label class="companyPicEdit">
                                                <input type="file" ref="myCompanyProfilepic"
                                                    accept="image/x-png, image/gif, image/jpeg"
                                                    @change="onCompanyProfile" />
                                                <img
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/editIcon.svg" />
                                            </label>
                                        </div>
                                        <div class="pull-right pb-10" style="position: absolute;right: 20px;">
                                            <div class="digi-card-header p-3 clearfix">
                                                <div class="float-left">
                                                    <div class="scan-label mt-12 mr-20"
                                                        style="color: #4e5764;font-size:16px;">Scan QR Code</div>
                                                </div>
                                                <div class="qrcode-block float-left mr-20 mt-2">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/qr-code.svg"
                                                        class="qr-logo" />
                                                    <qrcode-vue :value="company_details.website" :size="size" level="H"
                                                        background="#d6e2ef" foreground="#00448b"
                                                        class="qrcode-content"></qrcode-vue>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-25 row mb-15">
                                            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-1"></div>
                                            <div class="col-lg-10 col-md-10 col-sm-8 col-xs-10 formPadding">
                                                <form autocomplete="off">
                                                    <input autocomplete="off" name="hidden" type="text"
                                                        style="display:none;" />
                                                    <h6 class="mt-5 font-weight-bold fs-16">Company Information</h6>
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class="form-group">
                                                                <input class="inputField" name="company_name"
                                                                    v-on:blur="checkCompanyName" type="text"
                                                                    v-model="company_details.company_name"
                                                                    :maxlength="maxlengthcompanyname"
                                                                    v-validate="'required'" data-vv-scope="companyData"
                                                                    data-vv-as="Company Name"
                                                                    placeholder="Enter Company Name"
                                                                    oninput="this.value = this.value.toUpperCase()" />
                                                                <span class="inputBorder"></span>
                                                                <label class="inputLabel fs-14 fw-600">
                                                                    Company Name
                                                                    <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                </label>
                                                                <span
                                                                    class="character-count text-grey">{{maxlengthcompanyname - company_details.company_name.length}}/100</span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.company_name')">Company
                                                                    Name Is Required</span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-if="companyNameExists">Company Name already
                                                                    Exists!!</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5">
                                                        <div class="col-lg-12">
                                                            <div class>
                                                                <span class="text-secondary whiteSpace fs-14 fw-600">
                                                                    Domain Name
                                                                    <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                </span>
                                                                <input-tag class="digi-input-tags"
                                                                    v-model="company_details.company_domain"
                                                                    v-on:blur="getDomainNames()" :addTagOnBlur="true"
                                                                    name="company_domain" data-vv-as="Domain Name"
                                                                    v-validate="{required:true,regex:/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/}"
                                                                    data-vv-scope="companyData"
                                                                    placeholder="Enter Domain Name"></input-tag>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    v-if="domainIncorrect">Please Add Valid URL (Ex:
                                                                    digicollect.com, acoinvestment.com)</span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    v-if="!editDomainValid">
                                                                    Domain Name
                                                                    Already Exists
                                                                </span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.company_domain')">{{errors.first('companyData.company_domain')}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5">
                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                            <div class>
                                                                <span
                                                                    class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                    Industry Type
                                                                    <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                </span>
                                                                <v-select class="vselect-custom"
                                                                    placeholder="Select Industry Type"
                                                                    :clearable="false" :filterable="true"
                                                                    :options="companytype"
                                                                    style="width: 100%;margin-top: 7px;"
                                                                    data-vv-scope="companyData" v-validate="'required'"
                                                                    v-model="company_details.company_type"
                                                                    data-vv-as="Industry Type" name="company_type">
                                                                </v-select>
                                                                <span class="inputBorder"></span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    v-show="errors.has('companyData.company_type')">Industry
                                                                    Type Is Required</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                            <div class>
                                                                <span
                                                                    class="text-secondary whiteSpace vselectLabel fw-600">
                                                                    Number of Employees
                                                                </span>
                                                                <v-select class="vselect-custom"
                                                                    v-model="company_details.number_of_employees"
                                                                    placeholder="Select Number of Employees"
                                                                    :clearable="false" :filterable="true"
                                                                    name="number_of_employees"
                                                                    data-vv-as="Number of Employees"
                                                                    data-vv-scope="companyData"
                                                                    :options="['1 - 4', '5 - 9', '10 - 19', '20 - 49', '50 - 99', '100 - 249', '250 - 499', '500 - 999', '1,000 +']"
                                                                    style="width: 100%;margin-top: 7px;"></v-select>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.number_of_employees')">{{errors.first('companyData.number_of_employees')}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5">
                                                        <div class="col-lg-6 col-md-6 col-sm-6 pl-1">
                                                            <div class="form-group pt-0">
                                                                <span class="text-secondary pl-3 fw-600 fs-14">Date of
                                                                    Incorporation(dd/mm/yyyy)</span>
                                                                <date-picker :not-after="new Date()"
                                                                    name="date_of_incorporation"
                                                                    class="calendarYear mx-left calendar-edit-per pl-3"
                                                                    format="DD/MM/YYYY"
                                                                    v-model="company_details.date_of_incorporation"
                                                                    data-vv-as="Date Of Incorporation"
                                                                    :first-day-of-week="7" lang="en" :clearable="false"
                                                                    :editable="false" confirm confirm-text="APPLY"
                                                                    data-vv-scope="companyData"></date-picker>
                                                                <span class="invalid-feedback-form text-danger pl-3"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.date_of_incorporation')">{{errors.first('companyData.date_of_incorporation')}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                            <div class>
                                                                <span
                                                                    class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                    Time Zone
                                                                    <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                </span>
                                                                <v-select class="vselect-custom"
                                                                    placeholder="Select System Time" :clearable="false"
                                                                    :filterable="true" :options="timezone"
                                                                    @input="selectTimezone"
                                                                    style="width: 100%;margin-top: 7px;"
                                                                    data-vv-scope="companyData" v-validate="'required'"
                                                                    v-model="company_details.time_zone"
                                                                    data-vv-as="Time Zone" name="time_zone"></v-select>
                                                                <span class="invalid-feedback-form text-danger pl-3"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.time_zone')">{{errors.first('companyData.time_zone')}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="row mt-5">
                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                      <div class="">
                                                        <span class="text-secondary whiteSpace vselectLabel fw-600">Currency<sup class="fs-14 ml-02 mandatory">*</sup></span>
                                                        <v-select class="vselect-custom" placeholder="Select Currency" :clearable="false" :filterable="true" :options="currency" style="width: 100%;margin-top: 7px;" data-vv-scope="companyData" v-validate="'required'" v-model="company_details.currency" data-vv-as="Currency" name='currency'></v-select>
                                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('companyData.currency')">{{errors.first('companyData.currency')}}</span>
                                                      </div>
                                                    </div>
                          </div>-->
                                                    <div class="row mt-5">
                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                            <div class="form-group">
                                                                <input class="inputField" name="tax_id" type="text"
                                                                    v-model="company_details.tax_id"
                                                                    v-validate="'required'" data-vv-scope="companyData"
                                                                    data-vv-as="Tax Id" placeholder="Enter Tax ID" />
                                                                <span class="inputBorder"></span>
                                                                <label class="inputLabel fs-14 fw-600">
                                                                    Tax ID
                                                                    <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                </label>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.tax_id')">Tax Id is
                                                                    Required</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                            <div class>
                                                                <span
                                                                    class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                    Currency
                                                                    <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                </span>
                                                                <v-select class="vselect-custom"
                                                                    placeholder="Select Currency" :clearable="false"
                                                                    :filterable="true" :options="currency"
                                                                    @input="selectCurrency"
                                                                    style="width: 100%;margin-top: 7px;"
                                                                    data-vv-scope="companyData" v-validate="'required'"
                                                                    v-model="company_details.currency"
                                                                    data-vv-as="Currency" name="currency"></v-select>
                                                                <span class="invalid-feedback-form text-danger pl-3"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.currency')">{{errors.first('companyData.currency')}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5">
                                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                                            <div class>
                                                                <span
                                                                    class="text-secondary whiteSpace fw-600 fs-14">About</span>
                                                                <textarea-autosize class="digi-textarea"
                                                                    placeholder="Enter Text Here.."
                                                                    v-model="company_details.about"
                                                                    :min-height="minHeight" :max-height="maxHeight"
                                                                    :maxlength="maxlengthcompanyabout"
                                                                    data-vv-scope="companyData" data-vv-as="About"
                                                                    name="about_company" style="height:44px" />
                                                                <span
                                                                    class="character-count text-grey mr-4">{{maxlengthcompanyabout - company_details.about.length}}/1000</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <h6 class="mt-7 font-weight-bold fs-14">Fiscal Year Setup</h6>
                                                  <div class="row">

                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                      <div class="form-group">
                                                        <input class="inputField" v-model="company_details.fiscal_year" data-vv-scope="companyData" data-vv-as="Fiscal Year Name" type="text" name="fiscal_year_name" v-validate="'required'" placeholder="Enter Fiscal Year Name" autocomplete="off">
                                                        <span class="inputBorder"></span>
                                                        <label class="inputLabel fs-14 fw-600">Fiscal Year Name
                                                          <sup class="fs-14 ml-02 mandatory">*</sup>
                                                          <el-tooltip class="item" effect="dark" content='Sample “FY 20-21”' placement="top">
                                                              <i class="icon-information text-secondary iconsize-18 ml-3"></i>
                                                          </el-tooltip>
                                                        </label>
                                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('companyData.fiscal_year_name')">{{errors.first('companyData.fiscal_year_name')}}</span>
                                                      </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-6 pl-1">
                                                      <div class="form-group pt-0">
                                                        <span class="fs-14 text-secondary pl-3 fw-600 fs-14">Start Date(dd/mm/yyyy)<sup class="fs-14 ml-02 mandatory">*</sup></span>
                                                        <date-picker name="fiscal_start_year" class="calendarYear mx-left calendar-edit-per pl-3" format="DD/MM/YYYY" placeholder="Select Date" v-model="company_details.fiscal_year_start_date" data-vv-as="Fiscal Start Year" lang="en" :clearable="false" :editable="false" confirm confirm-text="APPLY" data-vv-scope="companyData" v-validate="'required'"></date-picker>
                                                        <span class="invalid-feedback-form text-danger pl-3" style="text-transform: none !important;" v-show="errors.has('companyData.fiscal_start_year')">{{errors.first('companyData.fiscal_start_year')}}</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="row mt-5">
                                                    <div class="col-lg-6 col-md-6 col-sm-6 pl-1">
                                                      <div class="form-group pt-0">
                                                        <span class="fs-14 text-secondary pl-3 fw-600 fs-14">End Date(dd/mm/yyyy)<sup class="fs-14 ml-02 mandatory">*</sup></span>
                                                        <date-picker name="fiscal_end_year" class="calendarYear mx-left calendar-edit-per pl-3" format="DD/MM/YYYY" placeholder="Select Date" v-model="company_details.fiscal_year_end_date" data-vv-as="Fiscal End Year" lang="en" :clearable="false" :editable="false" confirm confirm-text="APPLY" data-vv-scope="companyData" v-validate="'required'"></date-picker>
                                                        <span class="invalid-feedback-form text-danger pl-3" style="text-transform: none !important;" v-show="errors.has('companyData.fiscal_end_year')">{{errors.first('companyData.fiscal_end_year')}}</span>
                                                      </div>
                                                    </div>
                          </div>-->
                                                    <h6 class="mt-5 font-weight-bold fs-14">Communication Information
                                                    </h6>
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 col-sm-6"
                                                            style="margin-top: 28px;">
                                                            <span class="text-secondary whiteSpace fs-14 fw-600">
                                                                Company Primary Email
                                                            </span>
                                                            <div class="input-group">
                                                                <input type="text" class="form-control"
                                                                    v-model.trim="company_details.primary_email"
                                                                    name="primary_email" data-vv-scope="companyData"
                                                                    data-vv-as="Company Primary Email" :disabled="true"
                                                                    v-validate="{regex: /^(?:[A-Z\d][A-Z\d._]{4,50})$/i}"
                                                                    autocomplete="off"
                                                                    placeholder="Enter Company Primary Email"
                                                                    style="width: 1% !important;padding-left: 0px !important;cursor: not-allowed;" />
                                                                <!-- <span
                                  class="input-group-addon"
                                  style="border-bottom: 1px solid #a9aaad;margin-top: 2px;font-size: 20px;"
                                  v-if="!company_details.email.length"
                                  @click="customEmail()"
                                >
                                  <i
                                    class="icon-plus-circle-outline"
                                    style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"
                                  ></i>
                                </span>-->
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-6"
                                                            v-for="(mail, index) in company_details.email" :key="index">
                                                            <div class="form-group">
                                                                <input class="inputField"
                                                                    v-model="company_details.email[index].email_id"
                                                                    :maxlength="maxlengthcompanyotheremails"
                                                                    data-vv-scope="companyData" data-vv-as=" Email"
                                                                    v-validate="{required:true,regex: /^(?:[A-Z\d][A-Z\d._]{4,50})$/i}"
                                                                    type="text" :name="'email'+index.toString()"
                                                                    placeholder="Enter Email" />
                                                                <span class="inputBorder"></span>
                                                                <label class="inputLabel fs-14 fw-600">Alternate Email -
                                                                    {{index+1}}</label>
                                                                <span
                                                                    class="character-count text-grey">{{maxlengthcompanyotheremails - company_details.email[index].email_id.length}}/230</span>
                                                                <span class="input-group-addon removeBlocks"
                                                                    :class="{removedAdd: index+1!=company_details.email.length}"
                                                                    style="cursor: pointer;position: absolute;top: 28px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                    @click="company_details.email.splice(index,1)">
                                                                    <i class="icon-minus-circle-outline"
                                                                        style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                                <span class="input-group-addon"
                                                                    style="cursor: pointer;position: absolute;top: 28px;text-align: right;right: 0px;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                    @click="customEmail()"
                                                                    v-if="index+1==company_details.email.length">
                                                                    <i class="icon-plus-circle-outline"
                                                                        style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    v-show="errors.has('companyData.email'+index.toString())">{{errors.first('companyData.email'+index.toString())}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5"
                                                            v-if="company_details.email&&company_details.email.length!=0&&company_details.email.length%2==0">
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                                                            <div class style="margin-top: 2px;">
                                                                <span class="text-secondary whiteSpace fs-14 fw-600">
                                                                    Primary Phone Number
                                                                </span>
                                                                <vue-tel-input class="teleContact mt-2"
                                                                    name="phone_number"
                                                                    v-model="company_details.primary_phone.phone_number"
                                                                    v-on:country-changed="countryChanged($event, 'primary', index)"
                                                                    ref="telInput" placeholder="Enter Phone Number"
                                                                    :disabledFormatting="false"
                                                                    :valid-characters-only="true" v-validate="{min:15}"
                                                                    :maxLen="maxPhoneLength" data-vv-scope="companyData"
                                                                    data-vv-as="Phone Number" autocomplete="off">
                                                                </vue-tel-input>
                                                                <span class="input-group-addon"
                                                                    style="cursor: pointer;position: absolute;top: 30px;text-align: right;right: 0px;margin-right:20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                    @click="customPhone()"
                                                                    v-if="!company_details.phone_details.length">
                                                                    <i class="icon-plus-circle-outline"
                                                                        style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('companyData.phone_number')">{{errors.first('companyData.phone_number')}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5"
                                                            v-for="(phone, index) in company_details.phone_details"
                                                            :key="index">
                                                            <div class style="margin-top: 2px;">
                                                                <span class="text-secondary whiteSpace fs-14 fw-600">
                                                                    Alternate Phone Number -
                                                                    {{index+1}}
                                                                </span>
                                                                <vue-tel-input class="teleContact mt-2"
                                                                    :name="'phone_number'+index.toString()"
                                                                    v-model="company_details.phone_details[index].phone_number"
                                                                    v-on:country-changed="countryChanged($event, 'alternate', index)"
                                                                    ref="telInput" placeholder="Enter Phone Number"
                                                                    :disabledFormatting="false"
                                                                    :valid-characters-only="true"
                                                                    v-validate="{required:true,min:13}"
                                                                    :maxLen="maxPhoneLength" data-vv-scope="companyData"
                                                                    data-vv-as="Phone Number" autocomplete="off">
                                                                </vue-tel-input>
                                                                <span class="input-group-addon removeBlocksPhone"
                                                                    :class="{removedAddPhone: index+1!=company_details.phone_details.length}"
                                                                    style="cursor: pointer;position: absolute;top: 33px;margin-right:18px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                    @click="company_details.phone_details.splice(index,1)">
                                                                    <i class="icon-minus-circle-outline"
                                                                        style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                                <span class="input-group-addon"
                                                                    style="cursor: pointer;position: absolute;top: 33px;text-align: right;right: 0px;margin-right:17px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                    @click="customPhone()"
                                                                    v-if="index+1==company_details.phone_details.length">
                                                                    <i class="icon-plus-circle-outline"
                                                                        style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                </span>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    v-show="errors.has('companyData.phone_number'+index.toString())">{{errors.first('companyData.phone_number'+index.toString())}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5">
                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-1"
                                                            v-if="company_details.social_media.length!=1&&company_details.social_media.length%2==1">
                                                        </div>
                                                    </div>
                                                    <h6 class="mt-5 font-weight-bold fs-14">Branch Information</h6>
                                                    <div v-for="(branch, index) in company_details.branches"
                                                        :key="index">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div class="greybg doccrm mt-8">
                                                                    <div class="example">
                                                                        <div class="description">
                                                                            <div class="description-text">
                                                                                <h5 class="text-dark">Branch {{index+1}}
                                                                                    Information</h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField"
                                                                        :name="'branch_code'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchcode"
                                                                        data-vv-scope="companyData"
                                                                        data-vv-as="Branch Code"
                                                                        @blur="checkBranchExists" v-model="branch.code"
                                                                        type="text" placeholder="Enter Branch Code" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Branch Code
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchcode - branch.code.length}}/11</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_code'+index.toString())">{{errors.first('companyData.branch_code'+index.toString())}}</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-if="branchCodeDuplicates.includes(branch.code) && branch.code !== ''">
                                                                        This branch Code is already
                                                                        Entered
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField"
                                                                        :name="'branch_name'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchname"
                                                                        data-vv-scope="companyData"
                                                                        v-validate="'required'" data-vv-as="Branch Name"
                                                                        v-model="branch.name" type="text"
                                                                        placeholder="Enter Branch Name" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Branch Name
                                                                        <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchname - branch.name.length}}/40</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_name'+index.toString())">{{errors.first('companyData.branch_name'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input v-if="branch.hasOwnProperty('departments') && branch.departments && branch.departments.length > 0"
                                                                        class="inputField"
                                                                        :name="'department'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchname"
                                                                        @change="updateDepartment(index)"
                                                                        data-vv-scope="companyData"
                                                                        v-validate="'required'" data-vv-as="Department"
                                                                        v-model="branch.department" type="text"
                                                                        placeholder="Enter Department" />
                                                                    <input v-else class="inputField"
                                                                        :name="'department'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchname"
                                                                        @change="updateDepartment(index)"
                                                                        data-vv-scope="companyData"
                                                                        v-validate="'required'" data-vv-as="Department"
                                                                        v-model="branch.departments" type="text"
                                                                        placeholder="Enter Department" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Department
                                                                        <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchname - branch.departments ? branch.departments.length : 0}}/40</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.department'+index.toString())">{{errors.first('companyData.department'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h6 class="mt-5 font-weight-bold fs-14">Branch Communication
                                                            Information</h6>
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 col-sm-6 mt-6">
                                                                <div class="form-group">
                                                                    <input class="inputField"
                                                                        v-model="branch.primary_email"
                                                                        :maxlength="maxlengthcompanyprimaryemail"
                                                                        type="email" name="email"
                                                                        data-vv-scope="companyData"
                                                                        data-vv-as="Branch Email" v-validate="'email'"
                                                                        autocomplete="off" placeholder="Enter Email"
                                                                        style="padding: 15px 25px 5px 0px !important;" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Branch Email
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanyprimaryemail - branch.primary_email ? branch.primary_email.length : 0}}/230</span>

                                                                    <span class="input-group-addon"
                                                                        style="cursor: pointer;position: absolute;top: 28px;text-align: right;right: 0px;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                        @click="BranchCustomEmail(index)"
                                                                        v-if="branch.email && !branch.email.length">
                                                                        <i class="icon-plus-circle-outline"
                                                                            style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.email')">{{errors.first('companyData.email')}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6 mt-6"
                                                                v-for="(mail, branch_index) in branch.email"
                                                                :key="branch_index">
                                                                <div class="form-group">
                                                                    <input class="inputField"
                                                                        v-validate="'required|email'"
                                                                        :maxlength="maxlengthcompanyotheremails"
                                                                        v-model="branch.email[branch_index].email_id"
                                                                        data-vv-scope="companyData" data-vv-as=" Email"
                                                                        type="text"
                                                                        :name="'email'+branch_index.toString()"
                                                                        placeholder="Enter Email" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">Alternate
                                                                        Email - {{branch_index+1}}</label>
                                                                    <!-- {{branch.email[branch_index].email_type}} -->
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanyotheremails - branch.email[branch_index].email_id.length}}/230</span>
                                                                    <span class="input-group-addon removeBlocks"
                                                                        :class="{removedAdd: branch_index+1!=branch.email.length}"
                                                                        style="cursor: pointer;position: absolute;top: 28px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                        @click="branch.email.splice(branch_index,1)">
                                                                        <i class="icon-minus-circle-outline"
                                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="input-group-addon"
                                                                        style="cursor: pointer;position: absolute;top: 28px;text-align: right;right: 0px;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                        @click="BranchCustomEmail(index)"
                                                                        v-if="branch_index+1==branch.email.length">
                                                                        <i class="icon-plus-circle-outline"
                                                                            style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.email'+branch_index.toString())">{{errors.first('companyData.email'+branch_index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6 mt-5"
                                                                v-if="branch.email && branch.email.length!=0&&branch.email.length%2==0">
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                                                                <div class style="margin-top: 2px;">
                                                                    <span
                                                                        class="text-secondary whiteSpace fs-14 fw-600">
                                                                        Branch Phone Number
                                                                    </span>
                                                                    <vue-tel-input class="teleContact mt-2"
                                                                        :name="'branch_phone_number'+index.toString()"
                                                                        v-model="branch.primary_phone.phone_number"
                                                                        v-on:country-changed="countryChanged($event, 'branch_primary', 0)"
                                                                        ref="telInput" placeholder="Enter Phone Number"
                                                                        :disabledFormatting="false"
                                                                        :valid-characters-only="true"
                                                                        v-validate="{min:13}" :maxLen="maxPhoneLength"
                                                                        data-vv-scope="companyData"
                                                                        data-vv-as="Branch Phone Number"
                                                                        autocomplete="off"></vue-tel-input>
                                                                    <span class="input-group-addon"
                                                                        style="cursor: pointer;position: absolute;top: 30px;text-align: right;right: 0px;margin-right:20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                        @click="BranchCustomPhone(index)"
                                                                        v-if="!branch.phone_details.length">
                                                                        <i class="icon-plus-circle-outline"
                                                                            style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_phone_number'+index.toString()) && saveClicked">{{errors.first('companyData.branch_phone_number'+index.toString())}}</span>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-6 col-md-6 col-sm-6 mt-5"
                                                                v-for="(phone, branch_index) in branch.phone_details"
                                                                :key="branch_index">
                                                                <div class style="margin-top: 2px;">
                                                                    <span
                                                                        class="text-secondary whiteSpace fs-14 fw-600">
                                                                        Alternate Phone Number -
                                                                        {{branch_index+1}}
                                                                    </span>
                                                                    <vue-tel-input class="teleContact mt-2"
                                                                        :name="'phone_number'+branch_index.toString()"
                                                                        v-model="branch.phone_details[branch_index].phone_number"
                                                                        v-on:country-changed="countryChanged($event, 'branch_alt', index)"
                                                                        ref="telInput" placeholder="Enter Phone Number"
                                                                        :disabledFormatting="false"
                                                                        :valid-characters-only="true"
                                                                        v-validate="{required:true,min:13}"
                                                                        :maxLen="maxPhoneLength"
                                                                        data-vv-scope="companyData"
                                                                        data-vv-as="Branch Phone Number"
                                                                        autocomplete="off"></vue-tel-input>
                                                                    <span class="input-group-addon removeBlocksPhone"
                                                                        :class="{removedAddPhone: branch_index+1!=branch.phone_details.length}"
                                                                        style="cursor: pointer;position: absolute;top: 33px;margin-right:18px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                        @click="branch.phone_details.splice(branch_index,1)">
                                                                        <i class="icon-minus-circle-outline"
                                                                            style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="input-group-addon"
                                                                        style="cursor: pointer;position: absolute;top: 33px;text-align: right;right: 0px;margin-right:17px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                        @click="BranchCustomPhone(index)"
                                                                        v-if="branch_index+1==branch.phone_details.length">
                                                                        <i class="icon-plus-circle-outline"
                                                                            style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                    </span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.phone_number')">{{errors.first('userData.phone_number')}}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        data-vv-scope="companyData"
                                                                        v-validate="{regex:/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/}"
                                                                        v-model="branch.website"
                                                                        :maxlength="maxlengthbranchwebiste"
                                                                        :name="'branch_website'+index.toString()"
                                                                        data-vv-as="Branch Website Address"
                                                                        placeholder="Enter Branch Website Address" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Branch Website Address
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthbranchwebiste - branch.website.length}}/55</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_website'+index.toString())">{{errors.first('companyData.branch_website'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h6 class="mt-7 font-weight-bold fs-14">Branch Address</h6>
                                                        <div class="row">
                                                            <div
                                                                class="col-lg-6 d-flex flex-row align-items-center mt-5">
                                                                <span class="mr-4" style="color: #303031">Address Type
                                                                    :</span>
                                                                <div class="preview-elements">
                                                                    <div class="form-check form-check-inline user-perm">
                                                                        <label class="form-check-label check-label-dc"
                                                                            style="width: 80px !important;">
                                                                            <input class="form-check-input" type="radio"
                                                                                value="Office"
                                                                                v-model="branch.address.address_type" />
                                                                            <span class="radio-icon"></span>
                                                                            <span
                                                                                class="form-check-description fw-600">Office</span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline user-perm">
                                                                        <label class="form-check-label check-label-dc">
                                                                            <input class="form-check-input" type="radio"
                                                                                value="Factory"
                                                                                v-model="branch.address.address_type" />
                                                                            <span class="radio-icon"></span>
                                                                            <span
                                                                                class="form-check-description fw-600">Factory</span>
                                                                        </label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline user-perm">
                                                                        <label class="form-check-label check-label-dc">
                                                                            <input class="form-check-input" type="radio"
                                                                                value="Others"
                                                                                v-model="branch.address.address_type" />
                                                                            <span class="radio-icon"></span>
                                                                            <span
                                                                                class="form-check-description fw-600">Others</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-12 mt-5">
                                                                <div class="form-group pt-2 gMap"
                                                                    style="position:relative">
                                                                    <gmap-autocomplete class="input-white"
                                                                        id="autocompleteInput" name="get_location"
                                                                        v-validate="'required'"
                                                                        placeholder="Enter Address"
                                                                        @place_changed="setPlace($event,index)"
                                                                        :value="branch.address.meeting_location_vmodel"
                                                                        v-model="branch.address.meeting_location_vmodel"
                                                                        style="padding: 8px 32px 8px 12px !important;background-color: #ecf1f9; width: 100%; box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16); border-radius: 5.5px;">
                                                                    </gmap-autocomplete>
                                                                    <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                                        style="position: absolute;right: 12px;bottom: 10px;" />
                                                                </div>
                                                                <span class="invalid-feedback-form text-danger"
                                                                    style="text-transform: none !important;"
                                                                    v-show="errors.has('get_location')">Meeting Location
                                                                    is Required</span>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        data-vv-scope="companyData"
                                                                        :maxlength="maxlengthcompanybranchstreet"
                                                                        v-model="branch.address.street"
                                                                        data-vv-as="Branch Street"
                                                                        :name="'branch_street'+index.toString()"
                                                                        placeholder="Enter Street"
                                                                        oninput="this.value = this.value.toUpperCase()" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Street
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchstreet - branch.address.street.length}}/80</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_street'+index.toString())">{{errors.first('companyData.branch_street'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        :name="'branch_city'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchtownship"
                                                                        data-vv-as="Branch City"
                                                                        data-vv-scope="companyData"
                                                                        v-model="branch.address.city"
                                                                        placeholder="Enter City"
                                                                        oninput="this.value = this.value.toUpperCase()" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        City
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchtownship - branch.address.city.length}}/20</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_city'+index.toString())">{{errors.first('companyData.branch_city'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        data-vv-as="Branch Township"
                                                                        :maxlength="maxlengthcompanybranchtownship"
                                                                        :name="'branch_township'+index.toString()"
                                                                        data-vv-scope="companyData"
                                                                        v-model="branch.address.township"
                                                                        placeholder="Enter Township"
                                                                        oninput="this.value = this.value.toUpperCase()" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Township
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchtownship - branch.address.township.length}}/20</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_township'+index.toString())">{{errors.first('companyData.branch_township'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        data-vv-as="Branch State"
                                                                        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32)"
                                                                        :maxlength="maxlengthcompanybranchstate"
                                                                        :name="'branch_state'+index.toString()"
                                                                        placeholder="Enter State"
                                                                        data-vv-scope="companyData"
                                                                        v-model="branch.address.state"
                                                                        oninput="this.value = this.value.toUpperCase()" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        State
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchstate - branch.address.state.length}}/20</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_state'+index.toString())">{{errors.first('companyData.branch_state'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-5">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                        :name="'branch_pin_code'+index.toString()"
                                                                        :maxlength="maxlengthcompanybranchzipcode"
                                                                        data-vv-as="Branch Zip Code"
                                                                        placeholder="Enter Zip Code"
                                                                        data-vv-scope="companyData"
                                                                        v-model="branch.address.zip_code" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Zip Code
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanybranchzipcode - branch.address.zip_code.length}}/10</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_pin_code'+index.toString())">{{errors.first('companyData.branch_pin_code'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class>
                                                                    <span
                                                                        class="text-secondary whiteSpace vselectLabel fw-600 fs-14">
                                                                        Country
                                                                        <sup class="fs-14 ml-1 mandatory">*</sup>
                                                                    </span>
                                                                    <v-select class="vselect-custom"
                                                                        placeholder="Select Country" :clearable="false"
                                                                        :filterable="true" :options="countriesCaps"
                                                                        @input="branch.address.state = '',branch.address.city = '',branch.address.township = '',branch.address.zip_code = '',branch.address.meeting_location_vmodel = '',branch.address.building_number = '',branch.address.street = '',branch.address.street2 = ''"
                                                                        style="width: 100%;margin-top: 4px;"
                                                                        data-vv-scope="companyData"
                                                                        v-validate="'required'"
                                                                        v-model="branch.address.country"
                                                                        data-vv-as="Branch Country"
                                                                        :name="'branch_country'+index.toString()">
                                                                    </v-select>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.branch_country'+index.toString()) && !branch.address.country">{{errors.first('companyData.branch_country'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputFieldNew" type="text"
                                                                        placeholder="Enter Longitude"
                                                                        v-model="branch.address.latitude" hidden />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <div class="form-group">
                                                                    <input class="inputFieldNew" type="text"
                                                                        placeholder="Enter Longitude"
                                                                        v-model="branch.address.longitude" hidden />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-1">
                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                <div class="form-group">
                                                                    <input class="inputField" type="text"
                                                                        :name="'location_url'+index.toString()"
                                                                        :maxlength="maxlengthcompanylocationurl"
                                                                        data-vv-as="Branch Location URL"
                                                                        data-vv-scope="companyData" v-validate="'url'"
                                                                        v-model="branch.google_maps_url"
                                                                        placeholder="Enter Location URL" />
                                                                    <span class="inputBorder"></span>
                                                                    <label class="inputLabel fs-14 fw-600">
                                                                        Location URL
                                                                    </label>
                                                                    <span
                                                                        class="character-count text-grey">{{maxlengthcompanylocationurl - branch.google_maps_url.length}}/2048</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.location_url'+index.toString())">{{errors.first('companyData.location_url'+index.toString())}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="btn-align mt-8 d-flex justify-content-end">
                                                            <button type="button"
                                                                class="btn btn-white-secondary btn-smm mr-1"
                                                                style="box-shadow: none;"
                                                                v-if="index+1==company_details.branches.length"
                                                                @click="company_details.branches.push(JSON.parse(JSON.stringify(branchData)))">
                                                                + Add
                                                                Branch
                                                            </button>
                                                            <button type="button" class="btn btn-outline-danger btn-smm"
                                                                style="box-shadow: none;" v-if="index!=0"
                                                                @click="DeleteBranch(branch._id, index)">- Delete
                                                                Branch</button>
                                                        </div>
                                                    </div>
                                                    <div class="text-center py-6 pt-22">
                                                        <button type="button" @click="gobackCompanyProfile"
                                                            class="btn btn-danger btn-smm ml-3"
                                                            style="box-shadow: none;">CANCEL</button>
                                                        <button type="button" @click="saveEditCompany"
                                                            class="btn btn-secondary btn-smm ml-3"
                                                            style="box-shadow: none;">SAVE</button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-1"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import countries from "./json/countries.json";
    import bloodgroup from "./json/bloodgroup.json";
    import timezone from "./json/timezone.json";
    import currency from "./json/currency.json";
    import QrcodeVue from "qrcode.vue";
    import {
        company
    } from "./mixins/companySetup";
    import VueTelInput from "vue-tel-input";

    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import axios from "axios";
    import {
        EventBus
    } from './eventBus/nav-bar-event';
    const MAX_SIZE = 512000;
    export default {
        data() {
            return {
                tag: "",
                phonenumber: "",
                mobilenumber: "",
                countries: countries,
                countriesCaps: [],
                bloodgroup: bloodgroup,
                companytype: [],
                timezone: timezone,
                branchphonenumber: "",
                alternatebranchphonenumber: "",
                homenumber: "",
                worknumber: "",
                currency: currency,
                emergencycontactnumber: "",
                mobilenumber: "",
                roomtype: "",
                pillowtype: "",
                bedtype: "",
                bedsheettype: "",
                valueqr: "https://example.com",
                size: 90,
                phonelabel: "",
                dob: "",
                focusInput: false,
                genderType: "",
                account_id: "",
                company_details: {
                    logo: "/static/images/company-logo.png",
                    cover_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
                    company_name: "",
                    domain_name: [],
                    company_type: "",
                    number_of_employees: "",
                    date_of_incorporation: null,
                    company_domain: "",
                    about: "",
                    primary_email: "",
                    primary_phone: {
                        phone_type: "",
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                        //isvalid: "",
                    },
                    website: "",
                    email: [],
                    phone_details: [],
                    social_media: [{
                        account_type: "Facebook",
                        account_url: "",
                    }, ],
                    branches: [{
                        code: "",
                        name: "",
                        email: "",
                        website: "",
                        phone: "",
                        address: {
                            street: "",
                            city: "",
                            township: "",
                            state: "",
                            zip_code: "",
                            country: "",
                            latitude: "",
                            longitude: "",
                        },
                        google_maps_url: "",
                    }, ],
                },

                maxlengthcompanyname: 100,
                maxlengthemployees: 10,
                maxlengthcompanyabout: 1000,
                maxlengthprimaryemail: 230,
                maxlengthcompanyotheremails: 230,
                maxlengthprimarysocial: 150,
                maxlengthbranchwebiste: 55,
                maxlengthcompanyothersocial: 150,
                maxlengthcompanywebsite: 55,
                maxlengthcompanyprimaryemail: 230,
                maxlengthcompanyotheremails: 230,
                maxlengthcompanybranchcode: 11,
                maxlengthcompanybranchname: 40,
                maxlengthcompanybranchstreet: 80,
                maxlengthcompanybranchstate: 20,
                maxlengthcompanybranchzipcode: 10,
                maxlengthcompanylocationurl: 2048,
                maxlengthcompanyuserabout: 1000,
                maxlengthcompanysocial: 150,
                maxlengthcompanybranchtownship: 20,
                maxlengthPopup: 50,
                primaryemailPopover: false,
                othersemailPopover: false,
                primaryPhonePopover: false,
                othersphonePopover: false,
                branchprimaryemailPopover: false,
                branchothersemailPopover: false,
                branchprimaryphonePopover: false,
                branchothersphonePopover: false,
                saveClicked: false,
                maxPhoneLength: 15,
                ajaxCallinprogress: false,
                minHeight: 10,
                maxHeight: 350,
                editDomainValid: true,
                editDomainStart: 0,
                country: null,
                image: {
                    size: "",
                    // height:'',
                    // width:''
                },
            };
        },
        mixins: [company],
        components: {
            QrcodeVue,
            HalfCircleSpinner,
            VueTextareaAutosize,
        },
        methods: {
            // DialCode and Country Code
            countryChanged(country, variable, index) {
                switch (variable) {
                    case "primary":
                        this.company_details.primary_phone.dial_code = country.dialCode;
                        this.company_details.primary_phone.country_code = country.iso2;
                        break;

                    case "alternate":
                        this.company_details.phone_details[index].dial_code =
                            country.dialCode;
                        this.company_details.phone_details[index].country_code = country.iso2;
                        break;

                    case "branch_primary":
                        this.company_details.branches[index].primary_phone.dial_code =
                            country.dialCode;
                        this.company_details.branches[index].primary_phone.country_code =
                            country.iso2;
                        break;

                    case "branch_alt":
                        this.company_details.branches[index].phone_details[
                            branch_index
                        ].dial_code = country.dialCode;
                        this.company_details.branches[index].phone_details[
                            branch_index
                        ].country_code = country.iso2;
                        break;
                }
            },
            clearCustomValue(type) {
                if (type == "customEmailType") {
                    this.customEmailType = "";
                }
                if (type == "customPhoneType") {
                    this.customPhoneType = "";
                }
                if (type == "BranchCustomEmailType") {
                    this.BranchCustomEmailType = "";
                }
                if (type == "BranchCustomPhoneType") {
                    this.BranchCustomPhoneType = "";
                }
                if (type == "customUserEmailType") {
                    this.customUserEmailType = "";
                }
                if (type == "customUserPhoneType") {
                    this.customUserPhoneType = "";
                }
            },
            checkDataExists() {
                if (!this.companyNameExists && !this.checkBranchExists()) {
                    return true;
                } else {
                    return false;
                }
            },

            // Redirection to Company Profile View
            gobackCompanyProfile() {
                this.$router.push({
                    name: "CompanyProfile",
                    params: {
                        id: this.account_id,
                    },
                });
            },

            // Checking Domain Name
            // /employees/check_employees_exists_for_domain needs to be integrated
            async checkDomainName(domain_name) {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.post("/check_domain_names_validity", {
                        domain_names: domain_name,
                    });
                    resolve(response.data);
                });
            },

            // Getting Domain Names
            async getDomainNames() {
                for (
                    let i = this.getDomainNames; i < this.company_details.company_domain.length; i++
                ) {
                    let domainNameValidation = await this.checkDomainName(
                        this.company_details.company_domain[i]
                    );
                    this.editDomainValid = domainNameValidation.valid;
                }
            },

            // Edit Company Save
            saveEditCompany() {
                // this.getDomainNames();
                this.saveClicked = true;
                var moment = require("moment");
                let str = this.company_details.date_of_incorporation;
                let date = moment(str);
                this.company_details.date_of_incorporation = date.format();
                // this.company_details.branches[index].departments.push(this.company_details.branches[index].department)
                if (this.checkDataExists()) {
                    this.$validator.validateAll("companyData").then(result => {
                        if (result == true && this.editDomainValid && !this.domainIncorrect) {
                            this.editCompany(this.company_details);
                        } else {}
                    });
                }
            },
            //  phonenumber_valid(e, phoneType, index, branch_index) {
            //   if (phoneType == "primaryCompany") {
            //     this.company_details.primary_phone.country_code = e.countryCode;
            //     this.company_details.primary_phone.isvalid = e.isValid;
            //   }
            //   if (phoneType == "allCompany") {
            //     this.company_details.phone_details[index].country_code = e.countryCode;
            //     this.company_details.phone_details[index].isvalid = e.isValid;
            //   }

            //   if (phoneType == "emergency") {
            //     this.basic_information.emergency.emergency_contact_number.country_code =
            //       e.countryCode;
            //     this.basic_information.emergency.emergency_contact_number.isvalid =
            //       e.isValid;
            //   }
            //   if (phoneType == "primary") {
            //     this.basic_information.primary_phone.country_code = e.countryCode;
            //     this.basic_information.primary_phone.isvalid = e.isValid;
            //   }
            //   if (phoneType == "all") {
            //     this.basic_information.phone_details[index].country_code =
            //       e.countryCode;
            //     this.basic_information.phone_details[index].isvalid = e.isValid;
            //   }
            //   if (phoneType == "primaryBranches") {
            //     this.company_details.branches[index].primary_phone.country_code =
            //       e.countryCode;
            //     this.company_details.branches[index].primary_phone.isvalid = e.isValid;
            //   }
            //   if (phoneType == "allBranches") {
            //     this.company_details.branches[index].phone_details[
            //       branch_index
            //     ].country_code = e.countryCode;
            //     this.company_details.branches[index].phone_details[
            //       branch_index
            //     ].isvalid = e.isValid;
            //   }
            // },
            // validateStep() {
            //   var inValid = false;
            //   return inValid;
            // },
            showMapBusiness() {
                this.$modal.show("company_address_modal");
            },
            saveCompanyDetails() {
                this.$validator.validateAll().then(result => {
                    if (result == true) {} else {
                        //this.$toasted.global.error('Please Fill All Required Fields');
                    }
                });
            },

            // Cover Picture Change Function
            onCompanyBackground(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURL(input.files[0], attachment, "cover_pic");
                }
            },

            // Profile Picture Change Function
            onCompanyProfile(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURL(input.files[0], attachment, "profile_pic");
                }
            },
            getResumableURL(file, attachment, type) {
                let vuethis = this;
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http
                    .post("https://cloudapis.digicollect.com/external/upload_file", data)
                    .then(response => {
                        if (type == "profile_pic") {
                            vuethis.company_details.logo = response.data.url;
                            this.ajaxCallinprogress = false;
                            this.$awn.success("Uploaded Successfully");
                        } else if (type == "cover_pic") {
                            vuethis.company_details.cover_pic = response.data.url;
                            this.$awn.success("Uploaded Successfully");
                        }
                    })
                    .catch(error => {});
            },

            // Social Media Mutliple Adding
            addMedia: function () {
                var media = document.getElementById("addInputMedia");
                this.socialMedia.push({
                    text: "",
                });
            },
            removeMedia: function (index) {
                this.socialMedia.splice(index, 1);
            },

            // Delete Branch Function
            DeleteBranch(Id = null, index) {
                if (!Id) {
                    true;
                    this.company_details.branches.splice(index, 1);
                } else {
                    this.$http
                        .post("/branches/delete_branch", {
                            _id: Id,
                        })
                        .then(response => {
                            if (response.data.status_id == 1) {
                                this.company_details.branches.splice(index, 1);
                            }
                        })
                        .catch(error => {});
                }
            },
            selectTimezone(e) {
                this.company_details.time_zone = e.value;
            },
            selectCurrency(e) {
                this.company_details.currency = {
                    label: e.label,
                    symbol: e.symbol,
                };
            },
            async getCompanyDataById(params) {
                return new Promise(async (resolve, reject) => {
                    let response = await this.$http.post("/company/get_company_details", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                })
            },
            // Load Company Details Based on Account
            async loadCompanyData() {
                this.ajaxCallinprogress = true;
                let response = await this.$http.post("/company/get_company_details", {
                    account_id: this.$route.params.id,
                });
                if (response.data.status_id == 1) {
                    this.company_details = response.data.response;
                    this.ajaxCallinprogress = false;
                    this.company_details.branches.forEach((x, index) => {
                        this.company_details.branches[index].department = this.company_details
                            .branches[index].departments;
                        if(x.address) {
                            if (!("township" in x.address)) {
                                Object.assign(x.address, {
                                    township: "",
                                });
                            }
                            if (!("street" in x.address)) {
                                Object.assign(x.address, {
                                    street: "",
                                });
                            }
                            if (!("city" in x.address)) {
                                Object.assign(x.address, {
                                    city: "",
                                });
                            }
                            if (!("zip_code" in x.address)) {
                                Object.assign(x.address, {
                                    zip_code: "",
                                });
                            }
                            if (!("state" in x.address)) {
                                Object.assign(x.address, {
                                    state: "",
                                });
                            }
                            if (!("latitude" in x.address)) {
                                Object.assign(x.address, {
                                    latitude: 0,
                                });
                            }
                            if (!("longitude" in x.address)) {
                                Object.assign(x.address, {
                                    longitude: 0,
                                });
                            }
                        }
                        else {
                            this.company_details.branches[index].address = {
                                address_type: "",
                                city: "",
                                country: "",
                                latitude: 0,
                                longitude: 0,
                                state: "",
                                street: "",
                                township: "",
                                zip_code: ""
                            }
                        }
                        if(!("primary_phone" in x)) {
                            x.primary_phone = {
                                country_code: "",
                                dial_code: "",
                                phone_number: "",
                                phone_type: "primary"
                            }
                        }
                    });
                    if (!("about" in this.company_details)) {
                        Object.assign(this.company_details, {
                            about: "",
                        });
                    };
                }
                // this.loadcompanyData(this.$route.params.id)
                this.account_id = this.$route.params.id;
                setTimeout(() => {
                    this.ajaxCallinprogress = false;
                }, 500);
            },
            setPlace(place, index) {
                let currentPlace = place;
                let address = place.formatted_address.split(", ");
                this.company_details.branches[index].address.street =
                    address[address.length - 3] || "";
                this.company_details.branches[index].address.state =
                    address[address.length - 2] || "";
                this.company_details.branches[index].address.township =
                    address[address.length - 4] || "";
                this.company_details.branches[index].address.city = currentPlace.vicinity;
                this.company_details.branches[index].address.zip_code =
                    address[address.length - 2] || "";
                if (address[address.length - 1].includes("-")) {
                    let countrySelected = address[address.length - 1].split(" - ");
                    countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                            this.company_details.branches[index].address.country = x;
                        } else {
                            this.company_details.branches[index].address.country = "";
                        }
                    });
                } else {
                    this.company_details.branches[index].address.country = address[address.length - 1];
                }
                this.company_details.branches[index].address.latitude = currentPlace.geometry.location.lat() || "";
                this.company_details.branches[index].address.longitude = currentPlace.geometry.location.lng() || "";
                this.company_details.branches[index].address.meeting_location_vmodel = place.formatted_address;
            },
            async getIndustries() {
                let res = await this.$http.get("/company/get_industry_type");
                if (res.data.status_id == 1) {
                    this.companytype = res.data.response.value;
                }
            }
        },
        mounted() {
            this.countries.forEach(x => {
                this.countriesCaps.push(x.toUpperCase());
            });
            this.loadCompanyData();
            this.getIndustries();
            this.editDomainStart = this.company_details.company_domain.length;
        },
        watch: {
            // Watch Function for Domains
            "company_details.company_domain"(newVal, oldVal) {
                this.getDomainNames();
            },
        },
        created() {},
        computed: {},
    };
</script>
<style>
    .vue-form-wizard .wizard-tab-content {
        padding: 30px 0px 10px !important;
    }

    .vue-form-wizard .wizard-header {
        display: none !important;
    }

    .wizard-progress-bar {
        width: 88.8571% !important;
    }

    .vue-form-wizard .wizard-progress-bar {
        margin-left: 58px !important;
    }

    .vue-form-wizard .wizard-icon-circle.square_shape {
        border-radius: 13px !important;
    }

    .vue-form-wizard .wizard-icon-circle.square_shape {
        border-color: #d6e2ef !important;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked.square_shape {
        border-color: #00448b !important;
        background-color: #00448b !important;
    }

    .vue-form-wizard .wizard-icon-circle {
        border: 3px solid #d6e2ef;
        background-color: #d6e2ef;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon-container.square_shape,
    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon-container.tab_shape {
        border-radius: 6px !important;
        background-color: transparent !important;
    }

    .vue-form-wizard .wizard-icon-circle .wizard-icon {
        color: #00448b !important;
        font-size: 36px;
        width: 36px;
        height: 64px;
        line-height: 64px;
    }

    .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
        font-size: 36px;
        width: 36px;
        height: 64px;
        line-height: 64px;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon {
        color: #fff !important;
    }

    .vue-form-wizard .wizard-card-footer {
        position: absolute;
        margin-top: -70px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-left {
        float: none !important;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-right {
        float: none !important;
    }

    .vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn,
    .vue-form-wizard .wizard-btn {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 2px;
        background-color: transparent;
        font-size: 14px;
        font-weight: 600;
        padding: 6px 12px;
        min-width: 90px;
        height: 32px;
    }

    .vue-form-wizard .wizard-btn {
        display: inline-block;
        margin-bottom: 0;
        font-weight: 400;
        text-align: center;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        background-image: none;
        border: 1px solid transparent;
        white-space: nowrap;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        border-radius: 18px !important;
    }

    .stepTitle {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.21;
        letter-spacing: 0.6px;
        color: #303031;
        margin-top: 10px;
    }

    input[type="file"] {
        display: none;
    }

    .uploadCertificate .el-button--small {
        padding: 2px 20px 5px 10px !important;
        border-radius: 20px;
    }

    .fs-18 {
        font-size: 18px;
    }

    .saveProfile {
        width: 190px;
    }

    .selectPlaceholder {
        color: #cdd2da !important;
    }

    .form-group,
    .form-check.statuaryGroup {
        font-size: 1.6rem;
        will-change: auto !important;
        position: relative;
    }

    @media screen and (max-width: 576px) {
        .formPadding {
            margin-left: 17px;
            margin-right: 17px;
        }
    }

    .companyPic {
        display: block;
        position: absolute;
        left: 8%;
        top: 131px;
    }

    .companyPicEdit {
        position: absolute;
        top: 65px;
        right: 2%;
        cursor: pointer;
    }

    .custom-background-upload {
        width: 165px;
        height: 32px;
        float: right;
        right: 25px;
        position: absolute;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: #00448b;
        color: #ffffff;
        border-radius: 50px;
        top: 125px;
    }

    .socialMedia.dropdown-toggle::after {
        margin-left: 5px;
    }

    @-moz-document url-prefix() {
        .inputMedia {
            padding-right: 26px !important;
        }
    }

    .mediaDropdown.dropdown-menu {
        margin: 0rem 0rem 0 !important;
    }

    .doccrm .example>.description {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid transparent;
    }

    .doccrm .example>.description .description-text h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .doccrm .example>.description .toggle-source-preview {
        cursor: pointer;
        font-family: inherit;
        font-size: 12px;
        margin-left: auto;
        padding-left: 24px;
        color: rgba(0, 0, 0, 0.54);
    }

    .doccrm .example {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 0px;
        height: 100%;
        position: relative;
        opacity: 1;
        border-radius: 5px;
        background-color: rgba(205, 210, 218, 0.67);
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .doccrm .example>.description .description-text h5 {
        text-align: center;
        color: #303031 !important;
        font-size: 16px;
        font-weight: 600;
    }

    .qrcode-block {
        border-radius: 6px;
        border: solid 2px #00448b;
        background-color: #d6e2ef;
        width: 110px;
        height: 110px;
        position: relative;
        display: inline-block;
        white-space: nowrap;
        vertical-align: bottom;
    }

    .qrcode-content {
        text-align: center;
        margin: 7px auto;
    }

    .qr-logo {
        position: absolute;
        margin-top: 35px;
        margin-left: 40px;
        width: 30px;
    }

    .vue-phone-number-input.digiphone {
        font-family: "Poppins", sans-serif !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-input {
        background-color: transparent;
        position: relative;
        width: 100%;
        height: 34px;
        min-height: 34px;
        padding-right: 18px;
        padding-left: 0px;
        font-weight: 400;
        -webkit-appearance: none;
        outline: none;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
        border-radius: 0px;
        font-size: 13px !important;
        z-index: 0;
        margin-top: 15px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-selector-arrow {
        position: absolute;
        right: 0;
        top: calc(50% - 0px);
        width: 22px;
        color: #4e5764;
        -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        font-size: 12px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        text-align: center;
        display: inline-block;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-country-flag {
        margin: auto 0;
        position: absolute;
        top: 26px;
        left: 2px;
        z-index: 1;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.is-focused.has-value .field-input {
        padding-top: 0px;
        padding-left: 30px;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-input {
        padding-top: 0px;
        padding-left: 30px;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-hint .field-input {
        padding-top: 0px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-error .field-input {
        border-color: #ff4500 !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #ff4500 !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-label {
        position: absolute;
        top: 0px;
        left: 0px;
        -webkit-transform: translateY(25%);
        transform: translateY(25%);
        opacity: 0;
        font-size: 11px;
        color: #4e5764;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-label {
        color: #00448b !important;
        opacity: 0;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-input:not(.textarea) {
        height: 34px;
        min-height: 34px;
        margin-top: 15px;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value .field-input {
        padding-top: 0px;
    }

    .vue-phone-number-input.digiphone .field.vue-input-ui.input-phone-number.is-focused input.field-input {
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-input {
        cursor: pointer;
        background-color: #fff;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        position: relative;
        width: 100%;
        padding: 0 12px;
        font-weight: 400;
        -webkit-appearance: none;
        outline: none;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
        border-radius: 0px;
        font-size: 13px !important;
        z-index: 0;
        color: #303031;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-input {
        opacity: 1;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-label {
        position: absolute;
        top: 0px;
        cursor: pointer;
        left: 13px;
        -webkit-transform: translateY(25%);
        transform: translateY(25%);
        opacity: 0;
        -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        font-size: 11px;
        color: #4e5764;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.has-value .field-label {
        opacity: 0;
        color: #00448b;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-clear {
        position: absolute;
        top: 15px;
        bottom: 0;
        right: 8px;
        margin: auto 0;
        width: 24px;
        height: 24px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: none;
        background: transparent;
        color: #4e5764;
        border-radius: 24px;
        cursor: pointer;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-clear:hover {
        color: #fff;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value .field-input {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.has-value .field-input {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value input.field-input:not(.textarea) {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .select-country-container {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 90px;
        flex: 0 0 90px;
        width: 90px;
        min-width: 90px;
        max-width: 90px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item .dots-text {
        color: #303031;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item.selected .dots-text {
        color: #00448b;
        font-weight: 600;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item.keyboard-selected,
    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item:hover {
        background-color: #f5f6f9;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list {
        border-radius: 8px;
        -webkit-box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
        box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
    }

    .el-popper[x-placement^="right"] .popper__arrow {
        display: none;
    }

    .removeBlocks {
        right: 20px;
        margin-right: 2px;
    }

    .removeBlocks.removedAdd {
        right: 4px;
        margin-right: 2px;
    }

    .removeBlocksSocial {
        right: 18px;
        margin-right: 0px;
    }

    .removeBlocksSocial.removedAddSocial {
        right: 0px;
        margin-right: 4px !important;
    }

    .removeBlocksPhone {
        right: 18px;
        margin-right: 2px;
    }

    .removeBlocksPhone.removedAddPhone {
        right: 0px;
        margin-right: 2px;
    }

    .removeBlocksPhoneNew {
        right: 11px;
        margin-right: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/EditCompanyProfile.vue